function parseDownloadFilename(header) {
  if (!header) return null;

  const utf8 = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8) {
    try {
      return decodeURIComponent(utf8[1].trim());
    } catch {
      return utf8[1].trim();
    }
  }

  const quoted = header.match(/filename="([^"]+)"/i);
  if (quoted) return quoted[1];

  const plain = header.match(/filename=([^;]+)/i);
  return plain ? plain[1].trim() : null;
}

export async function requestFileDownload({
  files,
  serverUrl,
  token,
  filename = "files.zip",
  fetchImpl = fetch,
}) {
  if (!Array.isArray(files) || files.length === 0) {
    throw new Error("Select at least one file to download");
  }

  const response = await fetchImpl(`${serverUrl}/file/download`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { "x-access-token": token } : {}),
    },
    body: JSON.stringify({ files, filename }),
  });

  const contentType = response.headers.get("content-type") || "";
  if (!response.ok || contentType.includes("application/json")) {
    let message = `Download failed (${response.status || "unknown"})`;
    try {
      const body = await response.json();
      message =
        body?.error?.message ||
        body?.error?.msg ||
        body?.message ||
        message;
    } catch {
      // Keep the HTTP fallback when the error body is not JSON.
    }
    throw new Error(message);
  }

  return {
    blob: await response.blob(),
    filename:
      parseDownloadFilename(
        response.headers.get("content-disposition")
      ) || filename,
  };
}

export function saveBlobDownload(blob, filename) {
  const blobUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = blobUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(blobUrl);
}

export { parseDownloadFilename };
